<template>
    <div class="column is-6 is-3-widescreen">
        <div class="card utilities-card">
            <div class="card-content">
                <div class="content">
                    <div
                        class="utilities-icon"
                        :style="{ borderColor: $meta.header_colour }"
                    >
                        <b-icon
                            :pack="iconPack"
                            :icon="icon"
                            class="ml-0"
                            :style="{ color: $meta.header_colour }"
                        />
                    </div>

                    <h5 class="title is-6 mb-4 has-text-centered">
                        {{ type }}
                    </h5>

                    <nav
                        class="level"
                        :class="{'is-block': isReadingLong}"
                    >
                        <div class="level-left">
                            <p>
                                <span class="is-uppercase has-text-grey has-text-weight-semibold is-size-7">
                                    Start
                                </span>
                                <br />
                                <span class="utilities-number">
                                    {{ startReading | pad }}
                                </span>
                            </p>
                        </div>

                        <div class="level-right">
                            <p class="has-text-right">
                                <span class="is-uppercase has-text-grey has-text-weight-semibold is-size-7">
                                    End
                                </span>
                                <br />
                                <span class="utilities-number">
                                    {{ endReading | pad }}
                                </span>
                            </p>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    filters: {
        pad: function (value) {
            if(! value) {
                value = '';
            }
            return value.padStart(7, '0');
        },
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        iconPack: {
            type: String,
            required: false,
            default: 'fas',
        },
        startReading: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        endReading: {
            type: [Number, String],
            required: false,
            default: 0,
        },
    },

    computed: {
        isReadingLong: function () {
            return (this.startReading && this.startReading.length > 7) || (this.endReading && this.endReading.length > 7);
        },
    },
};
</script>

<style lang="scss">
.utilities-card
{
    margin-top: 4rem;

    .utilities-icon
    {
        background-color: #eeeeee;
        border-radius: 100%;
        border-width: 3px;
        border-style: solid;
        text-align: center;
        height: 95px;
        width: 95px;
        padding: 30px;
        box-sizing: content-box;
        margin: -4rem auto 1rem;

        span
        {
            font-size: 5.5rem;
            height: auto;
            width: auto;
        }
    }

    .utilities-number
    {
        font-family: 'Courier Prime', monospace;
        font-size: 1.3rem;
    }
}
</style>
